import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 8 — Grove's End (brief §6).
 *
 * The finale: a Creep and a Drifter in the same room, under a tight
 * moonlight budget instead of the usual slack. No block, of any kind, ever
 * kills a Chimera - only the ranged Tail skill or the Sunshard item does,
 * and Round 1 has neither. So the whole room is cleared by architecture,
 * exactly as pillar 4 (Starter solvability, no combat required) demands.
 *
 * The Creep patrols a short pillar-boxed stretch (same convention as Room 5)
 * that is too tight to dodge through safely by timing alone - verified by
 * running it, not assumed: even a fast, well-timed crossing collides with
 * the Creep more often than not. So the finale composes Room 5's ledge-route
 * technique instead: a three-step cast-and-climb staircase reaches a stone
 * ledge at row 7 spanning clean over both pillars, and the Creep is never
 * engaged at all. Past the ledge, the same Vine-crossing-and-reseal from
 * Room 7 walls off the Drifter, which has been closing the entire time.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1-7.
 */
export const grovesEnd: RoomDef = {
  id: '08-groves-end',
  name: "Grove's End",
  map: [
    '################',
    '#...........#..#',
    '#...........#..#',
    '#...........#..#',
    '#...........#..#',
    '#...........#..#',
    '#...........#..#',
    '#......####.#..#',
    '#...........#..#',
    '#....#...#..~..#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [{ kind: 'moonseed', tx: 13, ty: 9 }],
  chimera: [
    { kind: 'creep', x: 7, y: 10, dir: 1 },
    // Two tiles clear of the spawn tile, same reason as Room 7: a Drifter's
    // first step is immediate, and one tile of separation is an instant fail.
    { kind: 'drifter', x: 1, y: 9, dir: 1 },
  ],
  // Tight by design (brief §6): earlier rooms clear with 85+ of 90 moonlight
  // still on the clock. This one clears with roughly half its much smaller
  // budget spent, closer to the "genuinely hard, tight clock" the brief asks
  // the finale for than an ordinary room would be at the default 90.
  moonlight: 18,
};
